import Requests from './requests'
import Links from './links'
import { sprintf } from 'sprintf-js'

export default class Objects extends Requests {

  list (page = 1, query = '', sort = '', perPage = 0, count = false) {
    return this._getMany(page, query, sort, perPage, count)
  }

  get (id) {
    return this._getOne(id)
  }

  create (object) {
    return this._create(object)
  }

  update (object) {
    return this._update(object)
  }

  delete (id) {
    return this._delete(id)
  }

  links (id) {
    return new Links(sprintf('%s/%s', this.resource, id), this.backd)
  }

}



// WEBPACK FOOTER //
// ./src/objects.js